import { TileType, GameConfig, LevelConfig } from './types.js';

export const TILE_WIDTH = 48; // px (近似值，主要由CSS处理)
export const TILE_HEIGHT = 56; // px

export const GAME_CONFIG = {
  maxSlots: 7,
  maxRevives: 10,
};

export const ADV_ROUND = 3;

export const TILE_TYPES = [
  TileType.GRASS,
  TileType.FIRE,
  TileType.WATER,
  TileType.STUMP,
  TileType.WOOL,
  TileType.BELL,
  TileType.CARROT,
  TileType.SHEEP,
  TileType.CORN
];

// 难度曲线配置
export const getLevelConfig = (level) => {
  // 第1关：教学关，很少的牌，很少的种类
  let tileCountStart = 21;
  let tileCountAdd =  3;
  let TileCountMax = 150;

  let tileCount = tileCountStart + (level - 1) * tileCountAdd;
  tileCount = Math.min(tileCount, TileCountMax);

  let typeCount = 9;
  if(level >= 1 && level <= 2){
    typeCount = 3;
  }
  if(level >= 3 && level <= 5){
    typeCount = 4;
  }
  if(level >= 6 && level <= 7){
    typeCount = 5;
  }
  if(level >= 8 && level <= 9){
    typeCount = 6;
  }
  if(level >= 10 && level <= 11){
    typeCount = 7;
  }
  if(level >= 12 && level <= 13){
    typeCount = 8;
  }

  typeCount = Math.min(typeCount, TILE_TYPES.length);

  return { level, tileCount, typeCount };

  // if (level === 1) {
  //   return { level, tileCount: 21, typeCount: 3 }; // 7组
  // }
  // if (level === 2) {
  //   return { level, tileCount: 30, typeCount: 4 }; // 10组
  // }
  // if (level === 3) {
  //   return { level, tileCount: 39, typeCount: 5 }; // 13组
  // }
  // if (level === 4) {
  //   return { level, tileCount: 48, typeCount: 6 }; // 16组
  // }
  // if (level === 5) {
  //   return { level, tileCount: 57, typeCount: 7 }; // 19组
  // }
  // if (level === 6) {
  //   return { level, tileCount: 66, typeCount: 8 }; // 22组
  // }
  // if (level === 7) {
  //   return { level, tileCount: 75, typeCount: 9 }; // 25组
  // }


  // // 第4关及以后：难度线性增加，方块数量增加
  // // 限制最大方块数量以防止性能问题或过难
  // const baseTiles = 75;
  // const increment = (level - 7) * 9;
  // const tileCount = Math.min(150, baseTiles + increment); 
  
  // // 确保方块数量是3的倍数
  // const adjustedTileCount = tileCount - (tileCount % 3);

  // return {
  //   level,
  //   tileCount: adjustedTileCount,
  //   typeCount: 9 // 始终保持最大种类
  // };
};